<button
  [id]="id()"
  [type]="type()"
  [class]="btnClasses()"
  [disabled]="disabled()"
  class="w-fit transition-all duration-300 ease-in-out"
  [class.shadow-md]="useShadow()"
  [class.!justify-start]="textAlign() === 'left'"
  [class.!justify-center]="textAlign() === 'center'"
  [class.!justify-end]="textAlign() === 'right'">
  <ng-content />
</button>
